module.exports = __webpack_public_path__ + "03_veryshort_brown.6ff25e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_veryshort_brown.png
// module id = +eI4
// module chunks = 0